module.exports = __webpack_public_path__ + "static/media/4.922a1d2d.jpeg";